import {useContext} from "react";
import {ModalContext} from "./ModalProvider";

const ModalContainer = () => {
    const {currentModal} = useContext(ModalContext);

    return(
        <>
            {currentModal && (currentModal)}
        </>
    );
}

export default ModalContainer;